<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goProductAccountPage()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'PRODUCT_COMPARE.title' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="content-div">
    <div class="ion-margin ion-text-center">
      <ion-text class="font-20 font-med">{{ 'PRODUCT_COMPARE.lbl.find_right' | translate }}</ion-text>
    </div>
    <ion-grid fixed>
      <ion-row>
        <ion-col size="3">
          <ion-card class="ion-no-margin ion-text-center" color="light">
            <ion-grid fixed>
              <ion-row>
                <ion-col class="img-col ion-align-self-center">
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="header-col ion-align-self-center">
                  <ion-text class="font-16 font-med">{{ 'PRODUCT_COMPARE.lbl.access' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-12">{{ 'MODULE.list.guest' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-12">{{ 'MODULE.list.checkin' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-12">{{ 'MODULE.list.gift' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-12">{{ 'PRODUCT_COMPARE.lbl.num_device' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-12">{{ 'PRODUCT_COMPARE.lbl.num_guest' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-12">{{ 'PRODUCT_COMPARE.lbl.access_time' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-12">{{ 'PRODUCT_COMPARE.lbl.excel_import' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-12">{{ 'PRODUCT_COMPARE.lbl.offline' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-12">{{ 'LBL.platforms' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <!-- <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                </ion-col>
              </ion-row> -->
            </ion-grid>
          </ion-card>
        </ion-col>
        <ion-col size="3">
          <ion-card class="ion-no-margin ion-text-center" color="secondary">
            <ion-grid fixed>
              <ion-row>
                <ion-col class="img-col ion-align-self-center">
                  <ion-img class="product-img" [src]="'./assets/wedding/img/product/account/wedding_account_web.svg'"></ion-img>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="header-col ion-align-self-center">
                  <ion-text class="font-16 font-med">{{ 'PRODUCT.account.wedding_account_web.tiny' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then unlimited"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then unlimited"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then lifetime"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCloseMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-10 font-italic">{{ 'PRODUCT_COMPARE.lbl.web' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <!-- <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-10 font-italic" (click)="presentProductAccountDetailModal('wedding_account_web')">{{ 'LBL.detail' | translate }}</ion-text>
                </ion-col>
              </ion-row> -->
            </ion-grid>
          </ion-card>
        </ion-col>
        <ion-col size="3">
          <ion-card class="ion-no-margin ion-text-center" color="secondary">
            <ion-grid fixed>
              <ion-row>
                <ion-col class="img-col ion-align-self-center">
                  <ion-img class="product-img" [src]="'./assets/wedding/img/product/account/wedding_account_app.svg'"></ion-img>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="header-col ion-align-self-center">
                  <ion-text class="font-16 font-med">{{ 'PRODUCT.account.wedding_account_app.tiny' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then unlimited"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then unlimited"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then lifetime"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCloseMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-10 font-italic">{{ 'PRODUCT_COMPARE.lbl.app' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <!-- <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-10 font-italic" (click)="presentProductAccountDetailModal('wedding_account_app')">{{ 'LBL.detail' | translate }}</ion-text>
                </ion-col>
              </ion-row> -->
            </ion-grid>
          </ion-card>
        </ion-col>
        <ion-col size="3">
          <ion-card class="ion-no-margin ion-text-center" color="tertiary">
            <ion-grid fixed>
              <ion-row>
                <ion-col class="img-col ion-align-self-center">
                  <ion-img class="product-img" [src]="'./assets/wedding/img/product/account/wedding_account_full.svg'"></ion-img>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col class="header-col ion-align-self-center">
                  <ion-text class="font-16 font-med">{{ 'PRODUCT.account.wedding_account_full.tiny' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then unlimited"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then unlimited"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then lifetime"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ng-container *ngIf="true then circleCheckMark"></ng-container>
                </ion-col>
              </ion-row>
              <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-10 font-italic">{{ 'PRODUCT_COMPARE.lbl.all_platform' | translate }}</ion-text>
                </ion-col>
              </ion-row>
              <!-- <ion-row class="ion-align-items-center ion-justify-content-center">
                <ion-col class="ion-align-self-center content-col">
                  <ion-text class="font-10 font-italic" (click)="presentProductAccountDetailModal('wedding_account_full')">{{ 'LBL.detail' | translate }}</ion-text>
                </ion-col>
              </ion-row> -->
            </ion-grid>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="content-div ion-padding">
      <ion-button expand="block" (click)="goProductAccountPage()">{{ 'ACCOUNTS.premium.lbl.go_premium' | translate }}</ion-button>
      <div class="ion-text-center"><ion-text class="font-12 font-underline" (click)="goPremiumPage()">{{ 'ACCOUNTS.premium.lbl.why_premium' | translate }}</ion-text></div>
    </div>
  </ion-toolbar>
</ion-footer>

<ng-template #circleCheckMark>
  <div class="icon-div"><ion-icon class="icon-small" src="./assets/wedding/icon/checkin/tick-round.svg"></ion-icon></div>
</ng-template>
<ng-template #circleCloseMark>
  <div class="icon-div"><ion-icon class="icon-small" src="./assets/wedding/icon/checkin/close-round.svg"></ion-icon></div>
</ng-template>
<ng-template #unlimited>
  <ion-text class="font-10 font-italic">{{ 'PRODUCT_COMPARE.lbl.unlimited' | translate }}</ion-text>
</ng-template>
<ng-template #lifetime>
  <ion-text class="font-10 font-italic">{{ 'PRODUCT_COMPARE.lbl.lifetime' | translate }}</ion-text>
</ng-template>